module.exports = __webpack_public_path__ + "static/media/04-_DSC9128.64a60900.jpg";